/* Cross-sell slider for /tools/tracking. Rendered by snippets/ar-tracking-products.liquid.

   WHY THIS IS AN ASSET AND NOT AN INLINE SCRIPT, 2026-09-07.
   The snippet had accumulated TWO inline <script> blocks - a current one and a
   stale one left behind by a bad edit - so two versions of this code shipped on
   the same page and the stale one won the init flag. The arrows were wired to
   code that no longer existed in the file, and the page looked like a caching
   problem for an hour. One asset, loaded once from layout/theme.liquid, cannot
   be duplicated that way, and a `git`-less tree has no other guard against it.

   AND WHY THE MOTION IS HAND-ROLLED: any animated scroll needs
   requestAnimationFrame, which does not run in a hidden or background tab, so
   scroll-behavior: smooth / scrollBy({behavior:'smooth'}) / scrollIntoView all
   no-op there. Instant writes always land, so this animates frame by frame when
   the page is visible and falls back to one instant write when it is not. */
(function () {
  var VERSION = '3';
  var root = document.getElementById('ar-tk-slider');
  if (!root || root.dataset.arTkVersion === VERSION) return;
  root.dataset.arTkVersion = VERSION;
  var track = root.querySelector('.ar-tk-slider__track');
  var items = Array.prototype.slice.call(track.children);

  // WHY THE BUTTONS ARE CLONED FIRST, found 2026-09-07.
  // The app-proxy body arrives with a CACHED copy of an earlier version of
  // this script inside it, and that copy runs BEFORE this one - so a plain
  // "already initialised?" guard made the stale version the one in charge
  // and the arrows did nothing. Replacing each button with a clone drops
  // every listener any earlier copy attached, so the newest script owns
  // the controls no matter how many stale copies the cache serves.
  ['--prev', '--next'].forEach(function (suffix) {
    var b = root.querySelector('.ar-tk-slider__btn' + suffix);
    if (b) b.parentNode.replaceChild(b.cloneNode(true), b);
  });
  var prev = root.querySelector('.ar-tk-slider__btn--prev');
  var next = root.querySelector('.ar-tk-slider__btn--next');

  // WHY THE HAND-ROLLED ANIMATION, measured 2026-09-07.
  // Any animated scroll needs requestAnimationFrame, and rAF does not run
  // in a hidden or background tab - CSS scroll-behavior: smooth,
  // scrollBy({behavior:'smooth'}) and scrollIntoView all left scrollLeft
  // exactly where it started there, so an arrow click did nothing at all.
  // Instant writes land in every state (verified: 300 -> 298, 600 -> 596
  // with document.hidden true), so motion is animated frame by frame when
  // the page is visible and falls back to a single instant write when it
  // is not. Snapping is off for the duration or it fights each write;
  // targets are whole-card offsets, so it lands on a card regardless.
  var DUR = 380;

  function step() {
    return items.length > 1 ? items[1].offsetLeft - items[0].offsetLeft : track.clientWidth;
  }
  function perView() {
    return Math.max(1, Math.floor((track.clientWidth + 1) / step()));
  }
  function maxScroll() { return track.scrollWidth - track.clientWidth; }
  function sync() {
    // 2px of slack: sub-pixel card widths never land scrollLeft exactly on the end
    var max = maxScroll();
    root.toggleAttribute('data-fits', max <= 2);
    prev.disabled = track.scrollLeft <= 2;
    next.disabled = track.scrollLeft >= max - 2;
  }
  function animateTo(target) {
    target = Math.max(0, Math.min(target, maxScroll()));
    var start = track.scrollLeft, delta = target - start;
    var snapWas = track.style.scrollSnapType;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || document.hidden || Math.abs(delta) < 2) {
      track.scrollLeft = target; sync(); return;
    }
    track.style.scrollSnapType = 'none';
    var t0 = null, done = false;
    setTimeout(function () {
      if (!done) { track.scrollLeft = target; track.style.scrollSnapType = snapWas; sync(); }
    }, DUR + 150);
    requestAnimationFrame(function frame(ts) {
      if (t0 === null) t0 = ts;
      var p = Math.min(1, (ts - t0) / DUR);
      track.scrollLeft = start + delta * (1 - Math.pow(1 - p, 3));
      if (p < 1) { requestAnimationFrame(frame); }
      else { done = true; track.style.scrollSnapType = snapWas; sync(); }
    });
  }
  function page(dir) { return track.scrollLeft + dir * perView() * step(); }

  prev.addEventListener('click', function () { animateTo(page(-1)); });
  next.addEventListener('click', function () { animateTo(page(1)); });
  track.addEventListener('scroll', sync, { passive: true });
  window.addEventListener('resize', sync);
  // card images change the track width as they decode, so re-check then too
  Array.prototype.forEach.call(track.querySelectorAll('img'), function (img) {
    if (!img.complete) img.addEventListener('load', sync, { once: true });
  });
  sync();
})();
